export default {
      id: "sli-down-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#sli-down",
      toString: function () {
        return this.url;
      }
    }